import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedComprobantesAgregarValidosComponent {
  catalogos
  data
  operadora
  onChange

  $onChanges (changes) {
    if (changes.data && !changes.data.isFirstChange()) {
      let data = changes.data.currentValue
      this.data = [...data]
    }
  }

  actualizar (item, data) {
    this.data[this.data.indexOf(item)] = data
    this.onChange({$event: {detail: this.data}})
  }

  eliminar (item) {
    this.data.splice(this.data.indexOf(item), 1)
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('viaticosSharedComprobantesAgregarValidos', {
  controller: ViaticosSharedComprobantesAgregarValidosComponent,
  template,
  bindings: {
    catalogos: '<',
    data: '<',
    operadora: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/comprobantes/agregar/validos/component.js